import "mapbox-gl/dist/mapbox-gl.css";
import React, { useState, useRef, useEffect } from "react";
import MapGL, { MapRef, Marker } from "react-map-gl";
import { defaultMapStyle } from "../../map/Constants";
import { MapStylesMenu } from "../../map/MapStylesMenu";
import Pin from "../../map/pin";
import { ScaleBar } from "../../map/ScaleBar";

import { useHazardMap } from "../../riskAssessment/HazardMapContext";
import RenderHazardMap from "../../riskAssessment/RenderHazardMap";
import { defaultSourceLayer } from "../../riskAssessment/defaultSourceLayer";

const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

export const MineAssetMap = (props: { mineAsset: MiningAsset | null }) => {
  const { mineAsset } = props;

  const { selectedHazard, onHazardChange } = useHazardMap();

  const [sourceLayerData, setSourceLayerData] = useState(defaultSourceLayer); // when hazard config has source layer
  const [sourceLayerDataSecondary, setSourceLayerDataSecondary] = useState(defaultSourceLayer); // when hazard config has 2nd source layer

  const mapRef = useRef<MapRef>(null);

  const [viewState, setViewState] = useState<PartialViewState>({
    zoom: 16,
  });

  const [mapStyle, setMapStyle] = useState(defaultMapStyle);

  const setMapStyleAndClearHazardLayer = (mapStyle: string) => {
    onHazardChange(null);

    // setMapStyle(mapStyle);
    onStyleChange(mapStyle);
    setSourceLayerData(defaultSourceLayer);
    setSourceLayerDataSecondary(defaultSourceLayer);
    setIsBasicMapStyle(true);
  };

  // this was added to fix "Uncaught Error: Style is not done loading"
  const [isBasicMapStyle, setIsBasicMapStyle] = useState(true);
  const [styleLoaded, setStyleLoaded] = useState(false);
  const styleRevRef = useRef(0);

  const onStyleChange = (newStyle: string) => {
    if (mapStyle !== newStyle) {
      console.log("🔁 Changing map style to", newStyle);
      styleRevRef.current += 1; // force Map remount
      setStyleLoaded(false); // gate Sources until onLoad
      setMapStyle(newStyle);
    } else {
      console.log("ℹ️ Map style already set to", newStyle);
    }
  };

  useEffect(() => {
    if (mineAsset) {
      setViewState((old) => ({ ...old, latitude: mineAsset.latitude, longitude: mineAsset.longitude }));
    }
  }, [mineAsset]);

  const onMove = (viewState: PartialViewState) => {
    setViewState(viewState);
  };

  mapRef.current?.once("render", function () {
    mapRef.current?.resize();
  });

  return (
    <MapGL
      key={`map-${styleRevRef.current}`} // force full remount on style change
      {...viewState}
      ref={mapRef}
      mapboxAccessToken={TOKEN}
      style={{ width: "100%", height: "100%" }}
      mapStyle={mapStyle}
      onLoad={() => {
        setStyleLoaded(true);
        console.log("✅ Map loaded; style ready. rev:", styleRevRef.current, "style:", mapStyle);
      }}
      onMove={(evt) => onMove(evt.viewState)}
    >
      <RenderHazardMap
        setMapStyle={setMapStyle}
        selectedHazard={selectedHazard}
        sourceLayerData={sourceLayerData}
        setSourceLayerData={setSourceLayerData}
        sourceLayerDataSecondary={sourceLayerDataSecondary}
        setSourceLayerDataSecondary={setSourceLayerDataSecondary}
        styleLoaded={styleLoaded}
        isBasicMapStyle={isBasicMapStyle}
        setBasicMapStyle={setIsBasicMapStyle}
      />

      <Marker longitude={mineAsset?.longitude || 0} latitude={mineAsset?.latitude || 0}>
        <Pin size={20} />
      </Marker>
      <MapStylesMenu setMapStyle={setMapStyleAndClearHazardLayer}></MapStylesMenu>
      <ScaleBar zoom={viewState.zoom} />
    </MapGL>
  );
};
